// extracted by mini-css-extract-plugin
module.exports = {"enter":"FromRightSide_enter__13HM4","enterActive":"FromRightSide_enterActive__2TBh9","exit":"FromRightSide_exit__oL1VB","exitActive":"FromRightSide_exitActive__2ifHx"};